import { render, staticRenderFns } from "./response-assignment-quality.vue?vue&type=template&id=165e082c&scoped=true&"
import script from "./response-assignment-quality.vue?vue&type=script&lang=js&"
export * from "./response-assignment-quality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e082c",
  null
  
)

export default component.exports